import indexActivity from 'actions/activity/index';
import indexPhase from 'actions/phase/index';
import { scanToken } from 'actions/scan';
import React, { Component } from 'react';
import { getTranslate, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import Webcam from 'react-webcam';
import axios from 'axios';
import { motion, AnimatePresence } from 'framer-motion';
import Token from './components/Token/Token';
import TokenModal from './components/TokenModal/TokenModal';
import ScanInfoModal from './components/ScanInfoModal/ScanInfoModal';
import './Scan.module.scss';

const mapDispatchToProps = {
  indexActivity,
  indexPhase,
  scanToken,
};

const mapStateToProps = (state) => ({
  token: state.scan.token,
  scanning: state.scan.loading,
  activities: state.activity.entities,
  phases: state.phase.entities,
  scannerLoading: state.scan.loading,
  translate: getTranslate(state.localize),
});

class Scan extends Component {
  constructor(props) {
    super(props);

    this.state = {
      popupOpen: false,
      popupHidden: true,
      activitiesLoaded: false,
      foundToken: {},
      height: 0,
      notification: '',
      scanning: false,
      showModal: true,
    };

    this.tokens = [];

    this.takePicture = this.takePicture.bind(this);
    this.togglePopup = this.togglePopup.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.showPopup = this.showPopup.bind(this);
    this.hidePopup = this.hidePopup.bind(this);
    this.randomToken = this.randomToken.bind(this);
    this.findToken = this.findToken.bind(this);
    this.notification = this.notification.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.props.indexActivity().then(() =>
      this.setState({
        activitiesLoaded: true,
      })
    );
    this.props.indexPhase();

    // setTimeout(() => {
    //   this.notification(this.props.translate('scan.scan-notify'));
    // }, 2000);

    // Fix for the changing window size on mobile phones
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    // this.findToken('maken');
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ height: window.innerHeight });
  }

  notification(text) {
    this.setState({
      notification: text,
    });

    setTimeout(() => {
      this.setState({
        notification: '',
      });
    }, 5000);
  }

  togglePopup() {
    this.setState({
      popupOpen: !this.state.popupOpen,
    });
  }

  toggleModal() {
    setTimeout(() => {
      this.notification(this.props.translate('scan.scan-notify'));
    }, 10000);
    this.setState({
      showModal: !this.state.showModal,
    });
  }

  showPopup() {
    this.setState({
      popupHidden: false,
    });
  }

  hidePopup() {
    this.setState({
      popupHidden: true,
    });
  }

  takePicture() {
    // Don't take a picture when previous one is still loading
    if (this.state.scanning) return;

    // Hide the popup while looking for token
    this.hidePopup();

    // Reset the found token
    this.setState({
      foundToken: {},
      scanning: true,
    });

    // Start the token animation
    this.tokenInterval = setInterval(() => {
      this.tokens.push({
        token: this.randomToken(),
        final: false,
      });
      // Force a rerender
      this.setState({});
    }, 500);

    // Take the screenshot
    const screenshot = this.webcam.getScreenshot();

    console.log(screenshot);
    const image = this.dataURLtoBlob(screenshot);

    // Set the image to the python backend
    const formData = new FormData();
    formData.append('image', image);
    formData.append('_method', 'PUT');

    console.log(image);

    return axios
      .post('https://ai.prod1.studiotast.com/AR', formData)
      .then((response) => {
        // When a response is received, stop the animation
        clearInterval(this.tokenInterval);

        console.log(response);
        // The scanner recognised something
        if (response.data !== 'null') {
          if (response.data === 'no detection') {
            // Return when the response doesn't have a token
            console.log('no detection');

            this.setState({
              scanning: false,
            });

            setTimeout(() => {
              this.notification(
                this.props.translate('scan.error.block-not-recognized')
              );
            }, 300);
            return;
          }

          console.log(response.data[0].slug);

          // Look for the token in the store
          const tokenSlug = response.data[0].slug;
          const token = this.findToken(tokenSlug);

          if (!token) {
            this.notification(
              this.props.translate('scan.error.block-not-found')
            );

            this.setState({
              scanning: false,
            });

            return;
          }

          this.setState({
            foundToken: token,
          });

          this.setState({
            scanning: false,
          });

          setTimeout(() => {
            this.tokens.push({
              token,
              final: true,
            });
            setTimeout(() => this.showPopup(), 300);
          }, 100);
        }
        // The scanner didn't recognise anything
        else {
          this.setState({
            scanning: false,
          });

          setTimeout(() => {
            this.notification(
              this.props.translate('scan.error.block-not-recognized')
            );
          }, 300);
        }

        setTimeout(() => {
          this.tokens = [];
        }, 1000);
      })
      .catch(() => {
        clearInterval(this.tokenInterval);
        this.setState({
          scanning: false,
        });
        this.notification(this.props.translate('scan.error.generic'));
      });
  }

  dataURLtoBlob(dataurl) {
    if (!dataurl) return;

    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  randomToken() {
    const tokenLength = this.props.activities.allIds.length - 2;
    const randomIndex = parseInt(Math.random() * tokenLength) + 1;
    const token = this.props.activities.byId[randomIndex];
    return token;
  }

  findToken(slug) {
    const activities = Object.values(this.props.activities.byId);
    let token = activities.find((activity) => activity.slug === slug);

    if (!token) {
      const phases = Object.values(this.props.phases.byId);
      token = phases.find((phase) => phase.slug === slug);
    }

    return token;
  }

  render() {
    const videoConstraints = {
      width: 1920,
      height: 1080,
      facingMode: 'environment',
    };

    if (this.props.activities.length === 0) return null;

    const groowy = this.findToken('groowy');

    return (
      <div styleName="scanner">
        <div styleName="click-field" onClick={this.takePicture} />
        {this.state.notification && (
          <div styleName="notification-container">
            <div
              styleName="groowy"
              style={{ backgroundImage: `url(${groowy && groowy.thumbnail})` }}
            />
            <div styleName="notifications">
              {`"${this.state.notification}"`}
            </div>
          </div>
        )}
        <div styleName="frame">
          <svg
            version="1.0"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 228 228"
          >
            <g>
              <path
                fill="none"
                stroke="#FFFFFF"
                strokeWidth="3"
                strokeLinecap="round"
                strokeMiterlimit="10"
                d="M225.5,33.8V9.36
c0-3.79-3.07-6.86-6.86-6.86H194.2"
              />
              <path
                fill="none"
                stroke="#FFFFFF"
                strokeWidth="3"
                strokeLinecap="round"
                strokeMiterlimit="10"
                d="M2.5,194.2v24.44
c0,3.79,3.07,6.86,6.86,6.86H33.8"
              />
              <path
                fill="none"
                stroke="#FFFFFF"
                strokeWidth="3"
                strokeLinecap="round"
                strokeMiterlimit="10"
                d="M33.8,2.5H9.36
C5.57,2.5,2.5,5.57,2.5,9.36V33.8"
              />
              <path
                fill="none"
                stroke="#FFFFFF"
                strokeWidth="3"
                strokeLinecap="round"
                strokeMiterlimit="10"
                d="M194.2,225.5h24.44
c3.79,0,6.86-3.07,6.86-6.86V194.2"
              />
            </g>
          </svg>
        </div>
        {this.state.activitiesLoaded && this.tokens.length > 0 && (
          <>
            {this.tokens.map((item, index) => {
              const { token, final } = item;
              return token && <Token key={index} token={token} final={final} />;
            })}
          </>
        )}
        <Webcam
          audio={false}
          // screenshotWidth={640}
          videoConstraints={videoConstraints}
          screenshotFormat="image/jpeg"
          ref={(node) => (this.webcam = node)}
        />
        <TokenModal
          open={this.state.popupOpen}
          hidden={this.state.popupHidden}
          toggle={this.togglePopup}
          top={this.state.height - 100}
          tokens={{
            activities: this.props.activities.byId,
            phases: this.props.phases.byId,
          }}
          token={this.state.foundToken}
        />
        <AnimatePresence>
          {this.state.showModal && (
            <ScanInfoModal setModalIsOpen={this.toggleModal} />
          )}
        </AnimatePresence>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(Scan));
